export const calculatorList = [
  {
    id: 1,
    link: "/emi",
    backgroundColor: "btn-emi",
    name: { en: "Borrowing", mr: "कर्ज घेणे" },
  },
  {
    id: 2,
    link: "/sip",
    backgroundColor: "btn-sip",
    name: { en: "Investment", mr: "गुंतवणूक" },
  },
  {
    id: 3,
    link: "/lumpsum",
    backgroundColor: "btn-lump",
    name: { en: "Annuity", mr: "वार्षिकी" },
  },
  {
    id: 4,
    link: "/income-tax",
    backgroundColor: "btn-it",
    name: { en: "Income Tax", mr: "उत्पन्न कर" },
  },
  {
    id: 5,
    link: "/goldloan",
    backgroundColor: "btn-go",
    name: { en: "Gold Loan", mr: "गोल्ड लॉन" },
  },
];
